/**
 * This cant be a angular injection token because it used between nestjs, express and angular
 */
export const ENVIRONMENT_CONFIG_TRANSFER_STATE = 'ENVIRONMENT_CONFIG';
